import { render } from "./partners.vue?vue&type=template&id=147d2300&scoped=true&ts=true"
import script from "./partners.vue?vue&type=script&lang=ts"
export * from "./partners.vue?vue&type=script&lang=ts"

import "./partners.vue?vue&type=style&index=0&id=147d2300&scoped=true&lang=scss"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147d2300"]])

export default __exports__